// extracted by mini-css-extract-plugin
export default {"render":"assets_render__4zTGy","show":"assets_show__9Zu1m"};